import store  from '@/utils/store'
export const columns = (vm) =>{
    return [
        {
            type: 'index',
            width: 50,
            label: '序号',
            align:'center',
            headerAlign:'center',
        },
        {
            label:'账户类型',
            prop:'belongToType',
            align:'left',
            headerAlign:'left',
            tooltip:true,
            render: (h, params) => {
                let text = ""
                let color = ""
                let list = store.state.conText.accountTypeList
                for(var i in list){
                   if(params.row.belongToType*1 == list[i].val*1){
                      text = list[i].title
                      color = list[i].color
                   }
                }
                console.log()
                return h('span',{style:{color:color}},text)
            }
        },
        {
            label:'订单号',
            prop:'outTradeNo',
            align:'center',
            headerAlign:'center',
            width:200
        },
        
        // {
        //     label:'账户ID',
        //     prop:'id',
        //     align:'center',
        //     headerAlign:'center',
        
        // },
        {
            label:'账户名称',
            prop:'belongToName',
            align:'center',
            headerAlign:'center',
            width:200
        },
        {
            label:'产品名称',
            prop:'productName',
            align:'left',
            headerAlign:'left',
            width:200
        },
       
        {
            label:'IMEI序列号',
            prop:'serialNo',
            align:'left',
            headerAlign:'left',
            width:230
        },
        {
            label:'项目名称',
            prop:'projectName',
            align:'left',
            headerAlign:'left',
            width:260
        },
        {
            label:'区域位置',
            prop:'address',
            align:'left',
            headerAlign:'left',
            width:300
        },
        {
            label:'套餐名称',
            prop:'smName',
            align:'left',
            headerAlign:'left',
            width:260
        },
        {
            label:'平台续费到期时间',
            prop:'endTime',
            align:'left',
            headerAlign:'left',
            width:160,
            render: (h, params) => {
				let timeA = 0
				let timeB = 0
				let mark = true
	           if(!!params.row.endTime){
					 timeA =  (new Date(params.row.endTime)).getTime()
					 timeB =  new Date().getTime()*1
					 mark = timeA >  timeB ? true:false
			   }else{
				  mark = false
			   }
			   return h('span', { style:{color:mark ? "":"#E2282B"} }, !!params.row.endTime ? params.row.endTime:'--');
			}
        },
        {
            label:'状态',
            prop:'endTime',
            align:'left',
            headerAlign:'left',
            width:160,
            render: (h, params) => {
			   let obj = {
                '0':{
                    txt:'充值中',
                    color:'rgb(204, 167, 0)'
                },
                '1':{
                    txt:'成功',
                    color:'#009900'
                },
                '2':{
                    txt:'失败',
                    color:'#E2282B'
                }
               }
               let o = obj[params.row.status];
               
			   return h('span', { style:{color:o.color} }, o.txt);
			}
        },
        {
            label:'充值人',
            prop:'recharger',
            align:'center',
            headerAlign:'center',
            width:100
        },
        {
            label:'续费日期',
            prop:'consumeTime',
            align:'left',
            headerAlign:'left',
            width:160
        } 
    ]
}